// extracted by mini-css-extract-plugin
export default {"companyContainer":"_K-z","companyImage":"aL-z","container":"bL-z","heading":"cL-z","darkText":"dL-z","smallHeading":"eL-z","darkBackground":"fL-z","whiteBackground":"gL-z"};